import * as identityImg from "identity-img";
import { Link } from "react-router-dom";

import { ClefDisc, play_song_by_asset_id, stop, get_song_name_by_asset_id } from "clef-ui-sdk";

import CardStore from 'src/stores/CardStore';
import {ReactComponent as LikeIcon} from '../assets/icons/like_s.svg';
import {ReactComponent as UnLikeIcon} from '../assets/icons/unlike_s.svg';
import {ReactComponent as PinIcon} from '../assets/icons/pin.svg';
// import {ReactComponent as FillHeartIcon} from '../assets/icons/fill-heart.svg';
// import {ReactComponent as AccountIcon} from '../assets/icons/accountIcon.svg';

import { LazyLoadImage } from 'react-lazy-load-image-component';

import { ASSET_ID } from "src/constants/common";

import {ReactComponent as MiniPuzzleIcon} from '../assets/icons/miniPuzzleIcon.svg';
import {ReactComponent as UsdnIcon} from '../assets/tokens/xtn.svg';
import {ReactComponent as EggIcon} from '../assets/tokens/EGG.svg';
import {ReactComponent as UsdcIcon} from '../assets/tokens/usdc.svg';
import {ReactComponent as UsdtIcon} from '../assets/tokens/USDT.svg';
import {ReactComponent as WavesIcon} from '../assets/tokens/waves-logo.svg';
import {ReactComponent as PeteIcon} from '../assets/tokens/pete.svg';

import { useCallback, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import axios from "axios";
import NumberFormat from "react-number-format";
import { useStores } from "src/stores/useStores";
import { PinataSDK } from "pinata";

interface IMarketItemProps {
    item: CardStore;
    inWallet?: boolean;
    cb?: Function;
    burn?: boolean;
}

export default function MarketItem(props: IMarketItemProps) {
    const { accountStore, marketStore } = useStores();
    const [isAudio, setIsAudio] = useState<boolean|null>(null);
    const [isVideo, setIsVideo] = useState<boolean|null>(null);

    const [isPlay, setIsPlay] = useState<boolean>(false);
    const [playLoading, setPlayLoading] = useState<boolean>(false);

    const [sourceLoad, setSourceLoad] = useState<boolean>(false);
    const [clefName, setClefName] = useState<string>();

    const [imageUrl, setImageUrl] = useState(props.item.imageUrl);

    useEffect(() => {
        if (['wavesducks', 'waveslands', 'waves.domains'].some((w) => props.item.imageUrl.indexOf(w) >= 0)) {
            setSourceLoad(true);
        } else {
            axios.get(props.item.imageUrl).then((response) => {
                setSourceLoad(true);
                setImageUrl(props.item.imageUrl);
                if (response.headers?.['content-type'].indexOf('audio') >= 0) {
                    setIsAudio(true);
                } else if (response.headers?.['content-type'] !== 'video/mp4') {
                    setIsVideo(false);
                } else {
                    setIsVideo(true);
                }
            });
        }

        return () => {
        }
    }, [props.item.image]);

    const isClef = props.item?.creator === '3P4m4beJ6p1pMPHqCQMAXEdquUuXJz72CMe';

    useEffect(() => {
        if (isClef) {
            get_song_name_by_asset_id(props.item.assetId, {}).then((name) => {
                setClefName(name);
            });
        }
    }, []);

    let sellerImage = '';
    if (props.item.seller) {
        sellerImage = identityImg.create(props.item.seller, {size: 120})
    }

    const getButton = () => {
        let className = 'puzzle-nftMarketplace__button';
        let tooltip = '';
        const title = props.inWallet ?
            (props.item.isOnSell ? 'Cancel' : 'Sell') : props.item.isFree ? 'Take it' : 'Buy now';

        if (props.inWallet && props.item.isOnSell) {
            className += ' puzzle-nftMarketplace__button_cancel';
            tooltip = 'Withdraw from sale';
        } else if (!props.inWallet && !props.item.isOnSell) {
            className += ' puzzle-nftMarketplace__button_disabled';
        }

        const click = () => {
            return props.inWallet ?
                (props.item.isOnSell ? props.item.cancel(props?.cb) : null) : props.item.buy(props?.cb);
        }
        return props.inWallet && !props.item.isOnSell ?
            <Link to={props.item.marketLink}>
                <button
                disabled={!props.inWallet && !props.item.isOnSell}
                className={className} title={tooltip}>View</button></Link> :
            <button
                disabled={!props.inWallet && !props.item.isOnSell}
                className={className} title={tooltip} onClick={click}>{title}</button>
    }

    const pin = useCallback(() => {
        !props.item.isPinned ? props.item.pin(props?.cb) : props.item.pin(props?.cb, 'unpin');
    }, []);

    const marketButton = getButton();
    const sendToGatewayButton = props.inWallet ?
        (<button className="puzzle-gateway__button" onClick={() => {props.item.sendToGatewayHandler()}}>Send to Ethereum</button>) :
        <div></div>;

    // const rightBlockContainer = props.inWallet && props.item.isOnSell ?
    //     <div className='puzzle-nftMarketplace-flyBlock puzzle-nftMarketplace-flyBlock_right'>
    //         <div className='puzzle-nftMarketplace-flyBlock__text'>On sale</div>
    //     </div> : '';

    let rarity;
    let breeding;
    let generation;
    if (props.item.isDuck && props.item.characteristics) {
        rarity = props.item.characteristics.find(item => item.id === 'rarity');
        breeding = props.item.characteristics.find(item => item.id === 'breeding');
        generation = props.item.characteristics.find(item => item.id === 'generation');
    }

    return (
        <div className='puzzle-nftMarketplace__nftCard'>
            <div className="puzzle-nftMarketplace__nftSourceWrap" style={{backgroundColor: props.item.bgColor}}>
                {
                    isClef ?
                    <div
                        className='puzzle-nftMarketplace__clef'
                        onClick={async () => {
                            if (!isPlay) {
                                setPlayLoading(true);
                                await stop();
                                await play_song_by_asset_id(props.item.assetId, async () => {
                                    setIsPlay(!isPlay)
                                    setPlayLoading(false);
                                }, {});
                                setIsPlay(false);
                            } else {
                                await stop();
                                setIsPlay(false);
                            }
                        }}>
                        <ClefDisc assetID={props.item.assetId} isAnimate={isPlay}/>
                        {playLoading ? <div className='puzzle-nftMarketplace__clefLoading'>Loading...</div> : ''}
                    </div> :
                    sourceLoad && imageUrl && !isVideo && !isAudio ?
                        <Link
                            to={props.item.marketLink}
                            className='puzzle-nftMarketplace__nftImage'>
                                <LazyLoadImage
                                    src={imageUrl}
                                />
                            </Link>
                        :
                        isVideo && imageUrl ?
                            <Link
                            to={props.item.marketLink}
                            className='puzzle-nftMarketplace__nftVideo'
                            style={{ backgroundColor: props.item.bgColor}}>
                                <video autoPlay muted loop>
                                    <source src={imageUrl} type="video/mp4" />
                                </video>
                            </Link> :
                            isAudio && imageUrl ?
                                <div className="puzzle-nftMarketplace__nftAudio"><audio src={imageUrl} controls></audio></div> :
                                <Skeleton height={280} width="100%" baseColor="#c6c9f4"/>
                }
                {
                    props.item.isDuck && props.item.characteristics ?
                    <div className="puzzle-nftMarketplace-flyBlock puzzle-nftMarketplace-flyBlock_right" title={generation?.title}>
                        <div className="puzzle-nftMarketplace-flyBlock__text">{generation?.value}</div>
                    </div> : ''
                }
                {
                    !props.item.isPinned && accountStore.address === props.item.seller && (marketStore.daoMember || props.item.seller === '3P975LUuqc7uBPiSxp3nemf2FZh62zfirSh') ?
                    <div onClick={pin} title="Pin" className={`puzzle-nftMarketplace-flyBlock puzzle-nftMarketplace-flyBlock_right puzzle-nftMarketplace-flyBlockPin`}>
                        <div className="puzzle-nftMarketplace-flyBlock__text"><PinIcon width={16} height={16}/></div>
                    </div> : ''
                }
                {
                    props.item.isPinned ?
                    <div onClick={pin} title="Pinned" className={`puzzle-nftMarketplace-flyBlock puzzle-nftMarketplace-flyBlock_right puzzle-nftMarketplace-flyBlockPin ${props.item.isPinned ? 'puzzle-nftMarketplace-flyBlock_pinned' : ''}`}>
                        <div className="puzzle-nftMarketplace-flyBlock__text"><PinIcon width={16} height={16}/></div>
                    </div> : ''
                }
                {
                    props.item.isDuck && props.item.characteristics ?
                    <div className="puzzle-nftMarketplace__characteristics">
                        <div className="puzzle-nftMarketplace-flyBlock puzzle-nftMarketplace-flyBlock_normal" title={rarity?.title}>
                            <div className="puzzle-nftMarketplace-flyBlock__text">{rarity?.value}</div>
                        </div>
                        <div
                            className={'puzzle-nftMarketplace-flyBlock puzzle-nftMarketplace-flyBlock_normal puzzle-nftMarketplace-flyBlock_' + (breeding?.value ? 'green' : 'red')}
                            title={breeding?.value ? 'Can breed' : 'Can\'t breed'}>
                            <div className="puzzle-nftMarketplace-flyBlock__text">{breeding?.value ? 'Fertile' : 'Sterile'}</div>
                        </div>
                    </div> : ''
                }
                { props.item.achievements?.length ?
                    <div className='puzzle-nftMarketplace__achievements'>
                        { props.item.achievements.map((item) => {
                            return <img key={item} src={`https://wavesducks.com/ducks/achievements/${item}.png`} />
                        }) }
                    </div>
                : ''}
            </div>
            {
                props.item.sellerName ?
                    <Link
                        to={`/address/${props.item.seller}`}
                        title={props.item.seller}
                        className='puzzle-nftMarketplace-flyBlock'>
                        <img className="puzzle-nftMarketplace__accountIcon" src={sellerImage} alt={sellerImage} />
                        <div className='puzzle-nftMarketplace-flyBlock__text'>{props.item.sellerName}</div>
                </Link> : ''
            }
            <div className='puzzle-nftMarketplace__info'>
                <div className='puzzle-nftMarketplace__nftCollection'>
                    {
                        props.item.hasCollectionUrl ?
                            <Link to={props.item.collectionUrl}>{props.item.collectionName}</Link> :
                            props.item.collectionName
                    }
                </div>
                <div className="puzzle-nftMarketplace__nameBlock">
                    <Link className='puzzle-nftMarketplace__nftName' to={props.item.marketLink}>
                        {props.item.isDuck ? props.item.name.replace(/\s[0-9]+%/, "") : (clefName || props.item.name)}
                    </Link>
                    { props.item.isGroup ? <div className="puzzle-nftMarketplace__pcs">{props.item.groupAvailable}/{props.item.groupSize}</div> : ''}
                    { props.item.identical.items.length > 1 ? <div className="puzzle-nftMarketplace__pcs">({props.item.identical.items.length} pcs)</div> : '' }
                </div>
                {
                    props.item.isAllowLikes ?
                        <div className="puzzle-nftMarketplace__likeBlock">
                            {
                                props.item.isUserLiked ? <UnLikeIcon /> : <LikeIcon onClick={() => { props.item.like(props?.cb) }}/>
                            }
                            {props.item.likeCount ? <div className="puzzle-nftMarketplace__likeCount">{props.item.likeCount}</div> : ''}
                        </div> : ''
                }
            </div>
            <div className='puzzle-nftMarketplace__actions'>
                {
                    props.item.isOnSell || !props.inWallet ? 
                    <div className='puzzle-nftMarketplace__price'>
                        <div className='puzzle-nftMarketplace__priceCaption'>Price</div>
                        <div className='puzzle-nftMarketplace__asset'>
                            {props.item.buyOutAssetId === ASSET_ID.PUZZLE ?
                                <MiniPuzzleIcon style={{width: '20px', height: '20px'}} title="Puzzle"/> : ''}
                            {props.item.buyOutAssetId === ASSET_ID.USDN ?
                                <UsdnIcon style={{width: '24px', height: '20px'}} title="XTN"/> : ''}
                            {props.item.buyOutAssetId === ASSET_ID.PETE ?
                                <PeteIcon style={{width: '24px', height: '20px'}} title="PETE"/> : ''}
                            {props.item.buyOutAssetId === ASSET_ID.WAVES ?
                                <WavesIcon style={{width: '18px', height: '18px'}} title="Waves"/> : ''}
                            {props.item.buyOutAssetId === ASSET_ID.EGG ?
                                <EggIcon style={{width: '24px', height: '24px'}} title="Egg"/> : ''}
                            {props.item.buyOutAssetId === ASSET_ID.USDT ?
                                <UsdtIcon style={{width: '24px', height: '24px'}} title="USDT PPT"/> : ''}
                            {props.item.buyOutAssetId === ASSET_ID.USDC ?
                                <UsdcIcon style={{width: '24px', height: '24px'}} title="USDC PPT"/> : ''}
                            {props.item.buyOutAssetId === ASSET_ID.USDT_WX ?
                                <>
                                    <UsdtIcon style={{width: '24px', height: '24px'}} title="USDT WX"/>
                                    <div className="wx_label">wx</div>
                                </> : ''}
                            {props.item.buyOutAssetId === ASSET_ID.USDC_WX ?
                                <>
                                    <UsdcIcon style={{width: '24px', height: '24px'}} title="USDC WX"/>
                                    <div className="wx_label">wx</div>
                                </> : ''}
                            {
                                !props.item.isFree ? <span>&nbsp;</span> : ''
                            }
                            <span className='puzzle-nftMarketplace__priceValue'>{props.item.price}</span>
                            &nbsp;
                            {
                                props.item.usdtPrice ?
                                    <NumberFormat
                                        value={props.item.usdtPrice}
                                        thousandSeparator={true}
                                        prefix={'~ $'}
                                        displayType='text'
                                        decimalScale={2}
                                        title="USD"
                                        className='puzzle-nftMarketplace__priceUsdn'/> : ''
                            }
                        </div>
                        <Link
                            className="puzzle-nftMarketplace__bidsLink"
                            to={`/auction/${props.item.assetId}`}>
                            {props.item.bidsInfo || ''}
                            {
                                props.item.bidsInfo ?
                                    <NumberFormat
                                        value={props.item.bids[0].usdtPrice}
                                        thousandSeparator={true}
                                        prefix={' $'}
                                        decimalScale={2}
                                        displayType='text'/> : ''
                            }
                        </Link>
                    </div> : <div></div>
                }
                <div>
                    {marketButton}
                    {props.item && !props.item.isOnSell && props.item.quantity && props.burn ?
                        <button className="puzzle-nftMarketplace__button puzzle-nftMarketplace__button_red" onClick={() => {props.item.burn(props.cb)}}>Burn</button> : ''
                    }
                </div>
            </div>
        </div>
    )
}